import angular from "angular";
import moment from 'moment'
import $ from "jquery";
window.jQuery = $;
window.$ = $;

IndexController.$inject = [
  "$scope",
  "$location",
  "$rootScope",
  "$state",
  "network",
  "$localStorage",
  "Facebook",
  "$timeout",
  "cfpLoadingBar"
];

function IndexController(
  $scope,
  $location,
  $rootScope,
  $state,
  network,
  $localStorage,
  Facebook,
  $timeout,
  cfpLoadingBar
) {
  $scope.autocompleteOptions = {
    componentRestrictions: { country: "IN" }
  };
  
  $scope.loadLogin = "false";
  $scope.loadLoginData = "";
  $localStorage.jsbridgeAvail = "false";

  $scope.jsbridgeAvail = false;
  $scope.once = 0;
  
  $scope.userName = "";
  $scope.loginName = "";
  $scope.loginEmail = "";
  $scope.loginPassword = "";
  $scope.loginMobile = "";

  $scope.loginEmail = "";
  $scope.loginPassword = "";

  var loginType = "";
  var facebookuserId = "";
  var facebookAccessToken = "";
  var googleuserId = "";
  var googleAccessToken = "";

  var userName = "";
  var userBirthday = "";
  var userGender = "";
  var userEmail = "";

  $scope.SigningUpLoading = false;
  $scope.LoginButtonLoading = false;

  $scope.loadingFullScreen = false;
  
  $scope.keepInTouchEmail = "";
 
  $scope.isLoggedIn = function() {
    if ($localStorage.isLoggedIn) {
      $scope.userName = $localStorage.userName;
      return true;
    } else {
      return false;
    }
  };

  $scope.fireLogin = function() {
    var jbid = setInterval(frame, 3000);
    function frame() {
      if (typeof window.JSBridge !== "undefined") {
          clearInterval(jbid);
          $scope.jsbridgeAvail = true;
          $localStorage.jsbridgeAvail = "true";
          if (!$scope.isLoggedIn()) {
            $scope.loginPaytmIndex();
          }
      } 
    }
  }

  $scope.firePPLogin = function() {
    if (!$scope.isLoggedIn()) {
      //$scope.loginPPIndex();
    }
  }

  $scope.isH5Container = function(){
    const wwidth = window.innerWidth;
        if(wwidth > 320){
          const ua = window.navigator.userAgent;
          return /AppContainer/i.test(ua);
        } else {
          //return true;
          return false;
        }
  };

  $scope.isKaiOS = function(){
    return window.navigator.userAgent.indexOf("KAIOS") != -1;
  }

  $scope.isPPContainer = function(){
    const ua = window.navigator.userAgent;
    return /phonepe/i.test(ua);
  };

  $scope.checkInTime = [];
  $scope.checkInAllSlots = [];
  $scope.checkInSlots = [];
  $scope.maxSlotHour = 0;
 
  $scope.oncemax = true;
  $scope.countmax = 0;

  $scope.loginPaytmIndex = function(){
    var clientId = 'merchant-bookbyslot-prod';
    if($scope.loadLogin == 'false' && $scope.oncemax){
      $scope.oncemax = false;
      JSBridge.call('paytmFetchAuthCode', {
        clientId: clientId,
      }, function(result1) { 
        if(result1.data){
          $scope.loadLoginData = result1;
          $scope.loadLogin = "true";
          $scope.loadLoginFunc();
        } else {
          var textTry = 'OK';
          var showCancel = true;
          var consentText = "Login is mandatory to proceed";
          if(result1.error == -1){
            consentText = "Granting consent is necessary to proceed with the flow";
          }
          sweetAlert({
            title: " ",
            text: consentText,
            icon: "warning",
            showCancelButton: showCancel,
            cancelButtonText: 'Exit',
            confirmButtonText: textTry,
          },function(res){
            if(res){
              if($scope.countmax >= 2){
                JSBridge.call('popWindow');
              } else {
                $scope.countmax++;
                $scope.oncemax = true;
                $scope.loginPaytmIndex();
              }
            } else {
              JSBridge.call('popWindow');
            }
         });
        }
      });
    }
  } 

  $scope.loadLoginFunc = function(){ 
    if($scope.loadLogin == "true"){
      var result1 = $scope.loadLoginData;
      var openId = result1.data.openId;
      return network.paytmToken(result1.data.authId)
      .then(function(result2){
        var access_token = JSON.stringify(result2.data);
        return network.paytmUserDetails(access_token);
      }).then(function(res){
        if(res.data){
          var res = JSON.stringify(res.data);
          return network.paytmLogin(res, openId);
        }
      }).then(function(result4){
        if(result4.data.status == "success") {
          $localStorage.isLoggedIn = true;
          $localStorage.userId = result4.data.userId;
          $localStorage.authToken = result4.data.authToken;
          $localStorage.userName = result4.data.name;
          if (result4.data.countryCode) {
            $localStorage.countryCode = result4.data.countryCode;
          }
          if (result4.data.mobileNumber) {
            $localStorage.userMobile = result4.data.mobileNumber;
          }
          $localStorage.userEmail = result4.data.email;
          $scope.loadLogin = "false";
        }
        else {
          $scope.loadLogin = "false";
          sweetAlert({
            title: "Oops...",
            text: "It is required to enter the email address on Paytm profile in order to proceed.",
            icon: "warning"
          },function(res){
            $localStorage.isLoggedIn = false;
            JSBridge.call('popWindow');
          });
        }
      }).catch(function(e){
        $scope.loadLogin = "false";
        sweetAlert({
          title: "Oops...",
          text: "It is required to enter the email address on Paytm profile in order to proceed.",
          icon: "warning"
        },function(res){
          $localStorage.isLoggedIn = false;
          JSBridge.call('popWindow');
       });
      });
    }
  }

  $scope.loginPPIndex = function(){
    PhonePe.PhonePe.build(PhonePe.Constants.Species.web).then((sdk) => {
      sdk.fetchAuthToken().then((res) => {
        return network.ppLogin(res)
        .then(function(result4){
          if(result4.data.status == "success") {
            $localStorage.isLoggedIn = true;
            $localStorage.userId = result4.data.userId;
            $localStorage.authToken = result4.data.authToken;
            $localStorage.userName = result4.data.name;
            $localStorage.userMobile = result4.data.mobileNumber;
            $localStorage.userEmail = result4.data.email;
            $scope.loadLogin = "false";
          }
        })
        .catch((err) => {
          sweetAlert({
            title: "Oops...",
            text: 'Something went wrong',
            imageUrl: "assets/images/alrt-icon.png"
          });
        })
      }).catch((err) => {
        $("#login-dialog-button").click();
      })
    });
  } 

  $scope.signup = function() {
    if ($scope.loginName.trim() === "") {
      sweetAlert({
        title: "Oops...",
        text: "Please input user name",
        imageUrl: "assets/images/alrt-icon.png"
      });
    } else if ($scope.loginMobile === "") {
      sweetAlert({
        title: "Oops...",
        text: "Please input mobile number",
        imageUrl: "assets/images/alrt-icon.png"
      });
    } else if ($scope.loginMobile.toString().length != 10) {
      sweetAlert({
        title: "Oops...",
        text: "Please input 10 digit mobile number",
        imageUrl: "assets/images/alrt-icon.png"
      });
    } else if ($scope.loginEmail.trim() === "") {
      sweetAlert({
        title: "Oops...",
        text: "Please input email",
        imageUrl: "assets/images/alrt-icon.png"
      });
    } else if ($scope.loginPassword.trim() === "") {
      sweetAlert({
        title: "Oops...",
        text: "Please input password",
        imageUrl: "assets/images/alrt-icon.png"
      });
    } else {
      //console.log($scope.loginName +"\n"+ $scope.loginEmail +"\n"+ $scope.loginPassword);
      $scope.SigningUpLoading = true;
      network
        .signup(
          $scope.loginName,
          $scope.loginEmail,
          $scope.loginPassword,
          $scope.selectedMobileCode,
          $scope.loginMobile
        )
        .then(
          function(result) {
            $scope.SigningUpLoading = false;
            if (angular.equals(result.data.status, "success")) {
              sweetAlert("Success", result.data.data, "success");
              var magnificPopup = $.magnificPopup.instance;
              magnificPopup.close();
              $scope.loginName = "";
              $scope.loginMobile = "";
              $scope.loginEmail = "";
              $scope.loginPassword = "";
            } else {
              sweetAlert({
                title: "Oops...",
                text: result.data.error,
                imageUrl: "assets/images/alrt-icon.png"
              });
            }
          },
          function(result) {
            $scope.SigningUpLoading = false;
            sweetAlert({
              title: "Oops...",
              text: "Something went wrong!",
              imageUrl: "assets/images/alrt-icon.png"
            });
          }
        );
    }
  };

  $scope.login = function() {
    if ($scope.loginEmail === "") {
      sweetAlert({
        title: "Oops...",
        text: "Please input registered email",
        imageUrl: "assets/images/alrt-icon.png"
      });
    } else if ($scope.loginPassword === "") {
      sweetAlert({
        title: "Oops...",
        text: "Please input password to proceed",
        imageUrl: "assets/images/alrt-icon.png"
      });
    } else {
      //console.log($scope.loginEmail +"\n"+ $scope.loginPassword);
      loginType = "LOGIN";
      $scope.LoginButtonLoading = true;
      network.login($scope.loginEmail, $scope.loginPassword, loginType).then(
        function(result) {
          $scope.LoginButtonLoading = false;
          if (angular.equals(result.data.status, "success")) {
            try {
              //console.log(result);

              $localStorage.isLoggedIn = true;
              $localStorage.userId = result.data.userId;
              $localStorage.authToken = result.data.authToken;
              $localStorage.userName = result.data.name;
              $localStorage.IsCorporate = result.data.IsCorporate;
              $localStorage.userEmail = result.data.email;
              if (result.data.mobileNumber) {
                $localStorage.userMobile = result.data.mobileNumber;
                $localStorage.countryCode = result.data.countryCode;
              }

              var magnificPopup = $.magnificPopup.instance;
              magnificPopup.close();

              //console.log("auth:"+$localStorage.authToken);
              sweetAlert("Success", "Login Successful", "success");
            } catch (e) {
              // console.log("Error: " + e.description );
              sweetAlert({
                title: "Oops...",
                text: e.description,
                imageUrl: "assets/images/alrt-icon.png"
              });
              $scope.loginPassword = "";
            }
          } else {
            //console.log(result.data.error);
            sweetAlert({
              title: "Oops...",
              text: result.data.error,
              imageUrl: "assets/images/alrt-icon.png"
            });
            $scope.loginPassword = "";
          }
        },
        function(result) {
          sweetAlert({
            title: "Oops...",
            text: "Something went wrong!",
            imageUrl: "assets/images/alrt-icon.png"
          });
          //console.log("something went wrong...");
          $scope.LoginButtonLoading = false;
          $scope.loginPassword = "";
        }
      );
    }
  };

  $scope.loginFB = function() {
    $scope.isFBLogging = true;

    // console.log("Fb login");
    Facebook.login(
      function(response) {
        try {
          // console.log(response);
          if (!response.authResponse) {
            $scope.isFBLogging = false;
            sweetAlert({
              title: "Oops...",
              text: "Something went wrong!",
              imageUrl: "assets/images/alrt-icon.png"
            });
          } else {
            facebookuserId = response.authResponse.userID;
            facebookAccessToken = response.authResponse.accessToken;
            $scope.me();
          }
        } catch (e) {
          // console.log(e);
        }
      },
      {
        scope: "public_profile, email, user_birthday"
      }
    );
  };

  $scope.me = function() {
    Facebook.api(
      "/me",
      {
        fields: "name, email, gender, birthday"
      },
      function(response) {
        try {
          // console.log(response);
          userName = response.name;
          userGender = response.gender;
          userBirthday = response.birthday;
          userEmail = response.email;
          $scope.FBLoginNetwork();
        } catch (e) {
          // console.log(e);
        }
      }
    );
  };

  $scope.getLoginStatus = function() {
    Facebook.getLoginStatus(function(response) {
      if (response.status === "connected") {
        $scope.loggedIn = true;
      } else {
        $scope.loggedIn = false;
      }
    });
  };

  $scope.FBLogout = function() {
    Facebook.logout(function(response) {});
  };

  $scope.FBLoginNetwork = function() {
    loginType = "FB";
    network
      .facebookLogin(
        facebookuserId,
        facebookAccessToken,
        loginType,
        userName,
        userBirthday,
        userGender,
        userEmail
      )
      .then(
        function(result) {
          if (angular.equals(result.data.status, "success")) {
            try {
              $scope.isFBLogging = false;

              //console.log(result);
              $localStorage.isLoggedIn = true;
              $localStorage.userId = result.data.userId;
              $localStorage.authToken = result.data.authToken;
              $localStorage.userName = result.data.name;
              if (result.data.countryCode) {
                $localStorage.countryCode = result.data.countryCode;
              }
              if (result.data.mobileNumber) {
                $localStorage.userMobile = result.data.mobileNumber;
              }
              $localStorage.userEmail = userEmail;

              // console.log("auth:"+$localStorage.authToken);
              var magnificPopup = $.magnificPopup.instance;
              magnificPopup.close();
            } catch (e) {
              // console.log("Error: " + e.description );
            }
          } else {
            // console.log(result.data.error);
            sweetAlert({
              title: "Oops...",
              text: result.data.error,
              imageUrl: "assets/images/alrt-icon.png"
            });
          }
        },
        function(result) {
          // console.log("something went wrong...");
          sweetAlert({
            title: "Oops...",
            text: "Something went wrong!",
            imageUrl: "assets/images/alrt-icon.png"
          });
        }
      );
  };

  // google login

  $scope.loginGoogle = function() {
    $scope.isGoogleLogging = true;

    // console.log("google login");
    gapi.auth.signIn({
      clientid:
        "655403170774-c10vk6gk892snq7lbm3emik3tt7j8ih5.apps.googleusercontent.com",
      cookiepolicy: "single_host_origin",
      requestvisibleactions: "http://schemas.google.com/AddActivity",
      scope:
        "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile",
      callback: function(authResult) {
        // console.log(authResult);
        if (authResult.id_token) {
          googleAccessToken = authResult.id_token;
          // console.log("googleAccessToken:" + googleAccessToken);
          $scope.getUserInfo();
        }
      }
    });
  };

  $scope.getUserInfo = function() {
    gapi.client.request({
      path: "/oauth2/v3/userinfo",
      method: "GET",
      callback: function(userInfo) {
        // $scope.prepareGoogleData(userInfo);
        // console.log(userInfo);
        // console.log(userInfo.id);

        googleuserId = userInfo.sub;
        userName = userInfo.name;
        userGender = userInfo.gender;
        userEmail = userInfo.email;
        $scope.googleLoginNetwork();
      }
    });
  };

  $scope.googleLoginNetwork = function() {
    loginType = "GOOGLE";
    network
      .googleLogin(
        googleuserId,
        googleAccessToken,
        loginType,
        userName,
        userBirthday,
        userGender,
        userEmail
      )
      .then(
        function(result) {
          if (angular.equals(result.data.status, "success")) {
            try {
              $scope.isGoogleLogging = false;

              // console.log(result);
              $localStorage.isLoggedIn = true;
              $localStorage.userId = result.data.userId;
              $localStorage.authToken = result.data.authToken;
              $localStorage.userName = result.data.name;
              if (result.data.countryCode) {
                $localStorage.countryCode = result.data.countryCode;
              }
              if (result.data.mobileNumber) {
                $localStorage.userMobile = result.data.mobileNumber;
              }
              $localStorage.userEmail = userEmail;

              // console.log("auth:"+$localStorage.authToken);
              var magnificPopup = $.magnificPopup.instance;
              magnificPopup.close();
            } catch (e) {
              // console.log("Error: " + e.description );
            }
          } else {
            // console.log(result.data.error);
            sweetAlert({
              title: "Oops...",
              text: result.data.error,
              imageUrl: "assets/images/alrt-icon.png"
            });
          }
        },
        function(result) {
          // console.log("something went wrong...");
          sweetAlert({
            title: "Oops...",
            text: "Something went wrong!",
            imageUrl: "assets/images/alrt-icon.png"
          });
        }
      );
  };

  $scope.logout = function() {
    network.logout($localStorage.userId, $localStorage.authToken).then(
      function(result) {
        if (angular.equals(result.data.status, "success")) {
          try {
            // console.log(result);
            $localStorage.$reset();

            if (loginType === "FB") {
              $scope.FBLogout();
            } else if (loginType === "GOOGLE") {
              // console.log("google logout");
              gapi.auth.signOut();
            }
            sweetAlert({
              title: "See you soon",
              text: 'You have successfully logged out',
              icon: "success",
              timer: 1500
              },function () {
                sweetAlert.close();
            });
            $state.go("home", {}, { reload: true });
            // console.log("auth:"+$localStorage.authToken);
          } catch (e) {
            // console.log("Error: " + e.description );
          }
        } else {
          // console.log(result.data.error);
          sweetAlert({
            title: "Oops...",
            text: result.data.error,
            imageUrl: "assets/images/alrt-icon.png"
          });
        }
      },
      function(result) {
        // console.log("something went wrong...");
        sweetAlert({
          title: "Oops...",
          text: "Something went wrong!",
          imageUrl: "assets/images/alrt-icon.png"
        });
      }
    );
  };

  $scope.resetEmail = "";

  $scope.isValidEmail = function(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  $scope.showForgotPassword = function() {
    $(".modal").modal("hide");
    setTimeout(function() {
      $(".password-reset-modal").modal("show");
    }, 800);
  };

  $scope.passwordReset = function() {
    if ($scope.resetEmail.trim() == "") {
      swal({
        title: "Oops...",
        text: "Please enter an email address",
        imageUrl: "assets/images/alrt-icon.png"
      });
    } else if (!$scope.isValidEmail($scope.resetEmail.trim())) {
      swal({
        title: "Oops...",
        text: "Please enter a valid email address",
        imageUrl: "assets/images/alrt-icon.png"
      });
    } else {
      network.passwordReset($scope.resetEmail).then(
        function(res) {
          // console.log(res);
          if (res.data.status && res.data.status.toLowerCase() == "success") {
            swal("Requested!", res.data.message, "success");
            $scope.resetEmail = "";
            var magnificPopup = $.magnificPopup.instance;
            magnificPopup.close();
          } else if (res.data.error && res.data.error == "No User Found") {
            swal({
              title: "Oops...",
              text: "No user found with this email",
              imageUrl: "assets/images/alrt-icon.png"
            });
          } else {
            swal({
              title: "Oops...",
              text: "Something went wrong",
              imageUrl: "assets/images/alrt-icon.png"
            });
          }
        },
        function(err) {
          swal({
            title: "Oops...",
            text: "Something went wrong. Please try again.",
            imageUrl: "assets/images/alrt-icon.png"
          });
        }
      );
    }
  };

  $scope.subscribe = function() {
    if ($scope.keepInTouchEmail.trim() == "") {
      swal({
        title: "Oops...",
        text: "Please enter your email id to subscribe",
        imageUrl: "assets/images/alrt-icon.png"
      });
    } else {
      swal(
        "Thank you!",
        "We will keep you posted about news and latest offers",
        "success"
      );
      $scope.keepInTouchEmail = "";
    }
  };

  // Scroll page to the top whenever state changes
  $rootScope.$on("$stateChangeSuccess", function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  });
 
  // country code
  $scope.countryMobileCodesOld = [
    93,
    355,
    213,
    376,
    244,
    672,
    54,
    374,
    297,
    61,
    43,
    994,
    973,
    880,
    375,
    32,
    501,
    229,
    975,
    591,
    387,
    267,
    55,
    246,
    359,
    673,
    226,
    257,
    855,
    237,
    1,
    238,
    236,
    235,
    56,
    86,
    57,
    269,
    682,
    506,
    385,
    53,
    357,
    420,
    243,
    45,
    253,
    670,
    593,
    20,
    503,
    240,
    291,
    372,
    251,
    500,
    298,
    679,
    358,
    33,
    689,
    241,
    220,
    995,
    49,
    233,
    350,
    30,
    299,
    502,
    224,
    245,
    592,
    509,
    852,
    504,
    36,
    354,
    91,
    964,
    62,
    98,
    353,
    972,
    39,
    225,
    81,
    962,
    7,
    254,
    686,
    383,
    965,
    856,
    996,
    371,
    961,
    266,
    231,
    218,
    423,
    370,
    352,
    853,
    389,
    261,
    265,
    60,
    960,
    223,
    356,
    692,
    222,
    230,
    262,
    691,
    52,
    373,
    377,
    976,
    382,
    258,
    95,
    264,
    674,
    977,
    31,
    599,
    687,
    227,
    505,
    234,
    683,
    850,
    47,
    968,
    92,
    680,
    507,
    970,
    595,
    675,
    51,
    63,
    64,
    48,
    351,
    974,
    242,
    262,
    40,
    250,
    590,
    290,
    590,
    508,
    685,
    378,
    966,
    239,
    221,
    381,
    232,
    248,
    65,
    421,
    386,
    677,
    252,
    27,
    82,
    211,
    34,
    94,
    249,
    597,
    47,
    268,
    46,
    41,
    886,
    963,
    992,
    255,
    66,
    228,
    690,
    676,
    216,
    90,
    993,
    688,
    256,
    380,
    971,
    44,
    598,
    998,
    379,
    678,
    58,
    84,
    681,
    212,
    967,
    260,
    263
  ];

  $scope.countryMobileCodes = [
    { name: "Afghanistan", dial_code: "93", code: "AF" },
    { name: "Aland Islands", dial_code: "358", code: "AX" },
    { name: "Albania", dial_code: "355", code: "AL" },
    { name: "Algeria", dial_code: "213", code: "DZ" },
    { name: "AmericanSamoa", dial_code: "1684", code: "AS" },
    { name: "Andorra", dial_code: "376", code: "AD" },
    { name: "Angola", dial_code: "244", code: "AO" },
    { name: "Anguilla", dial_code: "1264", code: "AI" },
    { name: "Antarctica", dial_code: "672", code: "AQ" },
    { name: "Antigua and Barbuda", dial_code: "1268", code: "AG" },
    { name: "Argentina", dial_code: "54", code: "AR" },
    { name: "Armenia", dial_code: "374", code: "AM" },
    { name: "Aruba", dial_code: "297", code: "AW" },
    { name: "Australia", dial_code: "61", code: "AU" },
    { name: "Austria", dial_code: "43", code: "AT" },
    { name: "Azerbaijan", dial_code: "994", code: "AZ" },
    { name: "Bahamas", dial_code: "1242", code: "BS" },
    { name: "Bahrain", dial_code: "973", code: "BH" },
    { name: "Bangladesh", dial_code: "880", code: "BD" },
    { name: "Barbados", dial_code: "1246", code: "BB" },
    { name: "Belarus", dial_code: "375", code: "BY" },
    { name: "Belgium", dial_code: "32", code: "BE" },
    { name: "Belize", dial_code: "501", code: "BZ" },
    { name: "Benin", dial_code: "229", code: "BJ" },
    { name: "Bermuda", dial_code: "1441", code: "BM" },
    { name: "Bhutan", dial_code: "975", code: "BT" },
    { name: "Bolivia, Plurinational State of", dial_code: "591", code: "BO" },
    { name: "Bosnia and Herzegovina", dial_code: "387", code: "BA" },
    { name: "Botswana", dial_code: "267", code: "BW" },
    { name: "Brazil", dial_code: "55", code: "BR" },
    { name: "British Indian Ocean Territory", dial_code: "246", code: "IO" },
    { name: "Brunei Darussalam", dial_code: "673", code: "BN" },
    { name: "Bulgaria", dial_code: "359", code: "BG" },
    { name: "Burkina Faso", dial_code: "226", code: "BF" },
    { name: "Burundi", dial_code: "257", code: "BI" },
    { name: "Cambodia", dial_code: "855", code: "KH" },
    { name: "Cameroon", dial_code: "237", code: "CM" },
    { name: "Canada", dial_code: "1", code: "CA" },
    { name: "Cape Verde", dial_code: "238", code: "CV" },
    { name: "Cayman Islands", dial_code: " 345", code: "KY" },
    { name: "Central African Republic", dial_code: "236", code: "CF" },
    { name: "Chad", dial_code: "235", code: "TD" },
    { name: "Chile", dial_code: "56", code: "CL" },
    { name: "China", dial_code: "86", code: "CN" },
    { name: "Christmas Island", dial_code: "61", code: "CX" },
    { name: "Cocos (Keeling) Islands", dial_code: "61", code: "CC" },
    { name: "Colombia", dial_code: "57", code: "CO" },
    { name: "Comoros", dial_code: "269", code: "KM" },
    { name: "Congo", dial_code: "242", code: "CG" },
    {
      name: "Congo, The Democratic Republic of the Congo",
      dial_code: "243",
      code: "CD"
    },
    { name: "Cook Islands", dial_code: "682", code: "CK" },
    { name: "Costa Rica", dial_code: "506", code: "CR" },
    { name: "Cote d'Ivoire", dial_code: "225", code: "CI" },
    { name: "Croatia", dial_code: "385", code: "HR" },
    { name: "Cuba", dial_code: "53", code: "CU" },
    { name: "Cyprus", dial_code: "357", code: "CY" },
    { name: "Czech Republic", dial_code: "420", code: "CZ" },
    { name: "Denmark", dial_code: "45", code: "DK" },
    { name: "Djibouti", dial_code: "253", code: "DJ" },
    { name: "Dominica", dial_code: "1767", code: "DM" },
    { name: "Dominican Republic", dial_code: "1849", code: "DO" },
    { name: "Ecuador", dial_code: "593", code: "EC" },
    { name: "Egypt", dial_code: "20", code: "EG" },
    { name: "El Salvador", dial_code: "503", code: "SV" },
    { name: "Equatorial Guinea", dial_code: "240", code: "GQ" },
    { name: "Eritrea", dial_code: "291", code: "ER" },
    { name: "Estonia", dial_code: "372", code: "EE" },
    { name: "Ethiopia", dial_code: "251", code: "ET" },
    { name: "Falkland Islands (Malvinas)", dial_code: "500", code: "FK" },
    { name: "Faroe Islands", dial_code: "298", code: "FO" },
    { name: "Fiji", dial_code: "679", code: "FJ" },
    { name: "Finland", dial_code: "358", code: "FI" },
    { name: "France", dial_code: "33", code: "FR" },
    { name: "French Guiana", dial_code: "594", code: "GF" },
    { name: "French Polynesia", dial_code: "689", code: "PF" },
    { name: "Gabon", dial_code: "241", code: "GA" },
    { name: "Gambia", dial_code: "220", code: "GM" },
    { name: "Georgia", dial_code: "995", code: "GE" },
    { name: "Germany", dial_code: "49", code: "DE" },
    { name: "Ghana", dial_code: "233", code: "GH" },
    { name: "Gibraltar", dial_code: "350", code: "GI" },
    { name: "Greece", dial_code: "30", code: "GR" },
    { name: "Greenland", dial_code: "299", code: "GL" },
    { name: "Grenada", dial_code: "1473", code: "GD" },
    { name: "Guadeloupe", dial_code: "590", code: "GP" },
    { name: "Guam", dial_code: "1671", code: "GU" },
    { name: "Guatemala", dial_code: "502", code: "GT" },
    { name: "Guernsey", dial_code: "44", code: "GG" },
    { name: "Guinea", dial_code: "224", code: "GN" },
    { name: "Guinea-Bissau", dial_code: "245", code: "GW" },
    { name: "Guyana", dial_code: "595", code: "GY" },
    { name: "Haiti", dial_code: "509", code: "HT" },
    { name: "Holy See (Vatican City State)", dial_code: "379", code: "VA" },
    { name: "Honduras", dial_code: "504", code: "HN" },
    { name: "Hong Kong", dial_code: "852", code: "HK" },
    { name: "Hungary", dial_code: "36", code: "HU" },
    { name: "Iceland", dial_code: "354", code: "IS" },
    { name: "India", dial_code: "91", code: "IN" },
    { name: "Indonesia", dial_code: "62", code: "ID" },
    {
      name: "Iran, Islamic Republic of Persian Gulf",
      dial_code: "98",
      code: "IR"
    },
    { name: "Iraq", dial_code: "964", code: "IQ" },
    { name: "Ireland", dial_code: "353", code: "IE" },
    { name: "Isle of Man", dial_code: "44", code: "IM" },
    { name: "Israel", dial_code: "972", code: "IL" },
    { name: "Italy", dial_code: "39", code: "IT" },
    { name: "Jamaica", dial_code: "1876", code: "JM" },
    { name: "Japan", dial_code: "81", code: "JP" },
    { name: "Jersey", dial_code: "44", code: "JE" },
    { name: "Jordan", dial_code: "962", code: "JO" },
    { name: "Kazakhstan", dial_code: "77", code: "KZ" },
    { name: "Kenya", dial_code: "254", code: "KE" },
    { name: "Kiribati", dial_code: "686", code: "KI" },
    {
      name: "Korea, Democratic People's Republic of Korea",
      dial_code: "850",
      code: "KP"
    },
    { name: "Korea, Republic of South Korea", dial_code: "82", code: "KR" },
    { name: "Kuwait", dial_code: "965", code: "KW" },
    { name: "Kyrgyzstan", dial_code: "996", code: "KG" },
    { name: "Laos", dial_code: "856", code: "LA" },
    { name: "Latvia", dial_code: "371", code: "LV" },
    { name: "Lebanon", dial_code: "961", code: "LB" },
    { name: "Lesotho", dial_code: "266", code: "LS" },
    { name: "Liberia", dial_code: "231", code: "LR" },
    { name: "Libyan Arab Jamahiriya", dial_code: "218", code: "LY" },
    { name: "Liechtenstein", dial_code: "423", code: "LI" },
    { name: "Lithuania", dial_code: "370", code: "LT" },
    { name: "Luxembourg", dial_code: "352", code: "LU" },
    { name: "Macao", dial_code: "853", code: "MO" },
    { name: "Macedonia", dial_code: "389", code: "MK" },
    { name: "Madagascar", dial_code: "261", code: "MG" },
    { name: "Malawi", dial_code: "265", code: "MW" },
    { name: "Malaysia", dial_code: "60", code: "MY" },
    { name: "Maldives", dial_code: "960", code: "MV" },
    { name: "Mali", dial_code: "223", code: "ML" },
    { name: "Malta", dial_code: "356", code: "MT" },
    { name: "Marshall Islands", dial_code: "692", code: "MH" },
    { name: "Martinique", dial_code: "596", code: "MQ" },
    { name: "Mauritania", dial_code: "222", code: "MR" },
    { name: "Mauritius", dial_code: "230", code: "MU" },
    { name: "Mayotte", dial_code: "262", code: "YT" },
    { name: "Mexico", dial_code: "52", code: "MX" },
    {
      name: "Micronesia, Federated States of Micronesia",
      dial_code: "691",
      code: "FM"
    },
    { name: "Moldova", dial_code: "373", code: "MD" },
    { name: "Monaco", dial_code: "377", code: "MC" },
    { name: "Mongolia", dial_code: "976", code: "MN" },
    { name: "Montenegro", dial_code: "382", code: "ME" },
    { name: "Montserrat", dial_code: "1664", code: "MS" },
    { name: "Morocco", dial_code: "212", code: "MA" },
    { name: "Mozambique", dial_code: "258", code: "MZ" },
    { name: "Myanmar", dial_code: "95", code: "MM" },
    { name: "Namibia", dial_code: "264", code: "NA" },
    { name: "Nauru", dial_code: "674", code: "NR" },
    { name: "Nepal", dial_code: "977", code: "NP" },
    { name: "Netherlands", dial_code: "31", code: "NL" },
    { name: "Netherlands Antilles", dial_code: "599", code: "AN" },
    { name: "New Caledonia", dial_code: "687", code: "NC" },
    { name: "New Zealand", dial_code: "64", code: "NZ" },
    { name: "Nicaragua", dial_code: "505", code: "NI" },
    { name: "Niger", dial_code: "227", code: "NE" },
    { name: "Nigeria", dial_code: "234", code: "NG" },
    { name: "Niue", dial_code: "683", code: "NU" },
    { name: "Norfolk Island", dial_code: "672", code: "NF" },
    { name: "Northern Mariana Islands", dial_code: "1670", code: "MP" },
    { name: "Norway", dial_code: "47", code: "NO" },
    { name: "Oman", dial_code: "968", code: "OM" },
    { name: "Pakistan", dial_code: "92", code: "PK" },
    { name: "Palau", dial_code: "680", code: "PW" },
    { name: "Palestinian Territory, Occupied", dial_code: "970", code: "PS" },
    { name: "Panama", dial_code: "507", code: "PA" },
    { name: "Papua New Guinea", dial_code: "675", code: "PG" },
    { name: "Paraguay", dial_code: "595", code: "PY" },
    { name: "Peru", dial_code: "51", code: "PE" },
    { name: "Philippines", dial_code: "63", code: "PH" },
    { name: "Pitcairn", dial_code: "872", code: "PN" },
    { name: "Poland", dial_code: "48", code: "PL" },
    { name: "Portugal", dial_code: "351", code: "PT" },
    { name: "Puerto Rico", dial_code: "1939", code: "PR" },
    { name: "Qatar", dial_code: "974", code: "QA" },
    { name: "Romania", dial_code: "40", code: "RO" },
    { name: "Russia", dial_code: "7", code: "RU" },
    { name: "Rwanda", dial_code: "250", code: "RW" },
    { name: "Reunion", dial_code: "262", code: "RE" },
    { name: "Saint Barthelemy", dial_code: "590", code: "BL" },
    {
      name: "Saint Helena, Ascension and Tristan Da Cunha",
      dial_code: "290",
      code: "SH"
    },
    { name: "Saint Kitts and Nevis", dial_code: "1869", code: "KN" },
    { name: "Saint Lucia", dial_code: "1758", code: "LC" },
    { name: "Saint Martin", dial_code: "590", code: "MF" },
    { name: "Saint Pierre and Miquelon", dial_code: "508", code: "PM" },
    {
      name: "Saint Vincent and the Grenadines",
      dial_code: "1784",
      code: "VC"
    },
    { name: "Samoa", dial_code: "685", code: "WS" },
    { name: "San Marino", dial_code: "378", code: "SM" },
    { name: "Sao Tome and Principe", dial_code: "239", code: "ST" },
    { name: "Saudi Arabia", dial_code: "966", code: "SA" },
    { name: "Senegal", dial_code: "221", code: "SN" },
    { name: "Serbia", dial_code: "381", code: "RS" },
    { name: "Seychelles", dial_code: "248", code: "SC" },
    { name: "Sierra Leone", dial_code: "232", code: "SL" },
    { name: "Singapore", dial_code: "65", code: "SG" },
    { name: "Slovakia", dial_code: "421", code: "SK" },
    { name: "Slovenia", dial_code: "386", code: "SI" },
    { name: "Solomon Islands", dial_code: "677", code: "SB" },
    { name: "Somalia", dial_code: "252", code: "SO" },
    { name: "South Africa", dial_code: "27", code: "ZA" },
    { name: "South Sudan", dial_code: "211", code: "SS" },
    {
      name: "South Georgia and the South Sandwich Islands",
      dial_code: "500",
      code: "GS"
    },
    { name: "Spain", dial_code: "34", code: "ES" },
    { name: "Sri Lanka", dial_code: "94", code: "LK" },
    { name: "Sudan", dial_code: "249", code: "SD" },
    { name: "Suriname", dial_code: "597", code: "SR" },
    { name: "Svalbard and Jan Mayen", dial_code: "47", code: "SJ" },
    { name: "Swaziland", dial_code: "268", code: "SZ" },
    { name: "Sweden", dial_code: "46", code: "SE" },
    { name: "Switzerland", dial_code: "41", code: "CH" },
    { name: "Syrian Arab Republic", dial_code: "963", code: "SY" },
    { name: "Taiwan", dial_code: "886", code: "TW" },
    { name: "Tajikistan", dial_code: "992", code: "TJ" },
    {
      name: "Tanzania, United Republic of Tanzania",
      dial_code: "255",
      code: "TZ"
    },
    { name: "Thailand", dial_code: "66", code: "TH" },
    { name: "Timor-Leste", dial_code: "670", code: "TL" },
    { name: "Togo", dial_code: "228", code: "TG" },
    { name: "Tokelau", dial_code: "690", code: "TK" },
    { name: "Tonga", dial_code: "676", code: "TO" },
    { name: "Trinidad and Tobago", dial_code: "1868", code: "TT" },
    { name: "Tunisia", dial_code: "216", code: "TN" },
    { name: "Turkey", dial_code: "90", code: "TR" },
    { name: "Turkmenistan", dial_code: "993", code: "TM" },
    { name: "Turks and Caicos Islands", dial_code: "1649", code: "TC" },
    { name: "Tuvalu", dial_code: "688", code: "TV" },
    { name: "Uganda", dial_code: "256", code: "UG" },
    { name: "Ukraine", dial_code: "380", code: "UA" },
    { name: "United Arab Emirates", dial_code: "971", code: "AE" },
    { name: "United Kingdom", dial_code: "44", code: "GB" },
    { name: "United States", dial_code: "1", code: "US" },
    { name: "Uruguay", dial_code: "598", code: "UY" },
    { name: "Uzbekistan", dial_code: "998", code: "UZ" },
    { name: "Vanuatu", dial_code: "678", code: "VU" },
    {
      name: "Venezuela, Bolivarian Republic of Venezuela",
      dial_code: "58",
      code: "VE"
    },
    { name: "Vietnam", dial_code: "84", code: "VN" },
    { name: "Virgin Islands, British", dial_code: "1284", code: "VG" },
    { name: "Virgin Islands, U.S.", dial_code: "1340", code: "VI" },
    { name: "Wallis and Futuna", dial_code: "681", code: "WF" },
    { name: "Yemen", dial_code: "967", code: "YE" },
    { name: "Zambia", dial_code: "260", code: "ZM" },
    { name: "Zimbabwe", dial_code: "263", code: "ZW" }
  ];

  // $scope.countryMobileCodes.sort(function(a, b){return a-b});
  // $scope.countryMobileCodes.push('1-684','1-264','1-268','1-242','1-246','1-441','1-284','1-345','1-767','1-809','1-473','1-671',
  // '1-876','1-664','1-787','1-869','1-758','1-670','1-784','1-721','1-868','1-649','1-340','44-1481','44-1534','44-1624');

  $scope.selectedMobileCode = "91";

  $scope.mobileCodeSelected = function(item) {
    $scope.selectedMobileCode = item;
  };

  $timeout(function() {
    $scope.loadingFullScreen = true;
  }, 1000);

  $scope.reloadHome = function() {
    if ($state.current.name == "home") {
      $scope.$broadcast("eventName", { message: "reload" });
    } else {
      $state.go("home");
    }
  };
  $scope.canonicalHref = 'https://www.bookbyslot.com'+ $location.path();
  $scope.footerdate = "";
  $scope.footercheckintime = "07:00";
  $scope.footercheckintimeAMPM = "07:00 AM";
  if (moment(moment().format("HH:MM"), "HH:mm A").get("hour") >= 17) {
    $scope.footerdate = moment()
      .add(1, "days")
      .format("DD MMM YYYY");
    $scope.footercheckintime = "20:00";
    $scope.footercheckintimeAMPM = "08:00 PM";
  } else if (moment(moment().format("HH:MM A"), "HH:mm A").get("hour") < 7) {
    $scope.footerdate = moment().format("DD MMM YYYY");
  } else {
    //Added by Alok
    $scope.footerdate = moment().format("DD MMM YYYY");
    $scope.footercheckintime =
      moment(moment().format("HH:MM A"), "HH:mm A").get("hour") + 1 + ":00";
    $scope.footercheckintimeAMPM = moment(
      moment()
        .add(1, "hours")
        .format("hh:00 A"),
      "hh:mm A"
    )._i;
  }
  $scope.footerlinkdelhi =
    "https://www.bookbyslot.com/searchHours/Hourly/Delhi,%20India/28.68627380000001/77.22178310000004/" +
    $scope.footerdate +
    "/" +
    $scope.footercheckintime +
    "/" +
    $scope.footercheckintimeAMPM +
    "/4/India/Delhi/1/1/0";

  $scope.footerlinkchennai =
    "https://bookbyslot.com/searchHours/Hourly/Chennai,%20Tamil%20Nadu,%20India/13.0826802/80.27071840000008/" +
    $scope.footerdate +
    "/" +
    $scope.footercheckintime +
    "/" +
    $scope.footercheckintimeAMPM +
    "/4/India/Tamil%20Nadu/1/1/0";

  $scope.footerlinkmumbai =
    "https://bookbyslot.com/searchHours/Hourly/Mumbai,%20Maharashtra,%20India/19.0759837/72.87765590000004/" +
    $scope.footerdate +
    "/" +
    $scope.footercheckintime +
    "/" +
    $scope.footercheckintimeAMPM +
    "/4/India/Maharashtra/1/1/0";

  $scope.footerlinklucknow =
    "https://bookbyslot.com/searchHours/Hourly/Lucknow,%20Uttar%20Pradesh,%20India/26.8466937/80.94616599999995/" +
    $scope.footerdate +
    "/" +
    $scope.footercheckintime +
    "/" +
    $scope.footercheckintimeAMPM +
    "/4/India/Uttar%20Pradesh/1/1/0";

  $scope.footerlinkjaipur =
    "https://bookbyslot.com/searchHours/Hourly/Jaipur,%20Rajasthan,%20India/26.9124336/75.78727090000007/" +
    $scope.footerdate +
    "/" +
    $scope.footercheckintime +
    "/" +
    $scope.footercheckintimeAMPM +
    "/4/India/Rajasthan/1/1/0";

  $scope.footerlinkbangalore =
    "https://bookbyslot.com/searchHours/Hourly/Bengaluru,%20Karnataka,%20India/12.9715987/77.59456269999998/" +
    $scope.footerdate +
    "/" +
    $scope.footercheckintime +
    "/" +
    $scope.footercheckintimeAMPM +
    "/4/India/Karnataka/1/1/0";

  $scope.pad = function(n) {
    return n < 10 ? "0" + n : n;
  };
  
}

export default IndexController;
